import React, {useEffect, useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import 'yet-another-react-lightbox/styles.css';
import { SimpleSearch } from '../../../reduxToolkit/Search/SearchApi';
import {SEARCH_MODEL} from "../../../components/table/Model/TableModel";
import TableFunction from "../../../components/table/TableFunction";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: FullStack
 */
const ResourcesCardsApp = ({
                               view,
                               option,
                               selectedList,
                               setSelectedList,
                               setBodyForExport,
                               searchElement,
                               setIsAllChecked,
                               modified,
                               setModified
                           }) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const dispatch = useDispatch();
    const elementRef = useRef(null);

    useEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [results?.content]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, key:searchElement })
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    // Using the TableFunction helper to generate the table elements
    const { t, handleCheckboxChange,handleDeleteAll, pagination, rowsPerPage } = TableFunction({
        selectedList,
        setSelectedList, // Callback to set the selected rows
        data: results, // Table data
        setIsAllChecked,
        fixedPagination:false,
        hasContainer:true,
        labelRowsPerPage: 'resources_per_page',
        view,
        searchElement,//New
        getData,//New
        modified,//New
        setModified//New
    });

    return {
        rowsPerPage,
        contractorId,
        supplierId,
        t,
        DEV,
        permission,
        handleDeleteAll,
        handleCheckboxChange,
        pagination,
        results,
        setResults,
        elementRef
    };
};
export default ResourcesCardsApp;
